import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import axios from 'axios';
import * as $ from 'jquery';
import './career-programme-component.component.scss';
var CareerProgrammeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CareerProgrammeComponent, _super);
    function CareerProgrammeComponent(element) {
        return _super.call(this, element) || this;
    }
    CareerProgrammeComponent.prototype.init = function () {
        var _this = this;
        this.varUrl = "https://api.smartrecruiters.com/v1/companies/StandardBankGroup/postings";
        this.varLimit = 10;
        this.varOffset = 0;
        this.varDestination = 'PUBLIC';
        // this.varLanguage = 'en';
        this.varLocationType = 'ANY';
        this.varDepartment = '';
        this.varPaginationIndex = 0;
        this.containerLoader = this.element.querySelector('.career-programme-component__loader');
        this.containerResults = this.element.querySelector('.career-programme-component__results');
        this.containerEmpty = this.element.querySelector('.career-programme-component__empty');
        this.containerPagination = this.element.querySelector('.career-programme-component__pagination');
        this.buttonPaginationPrevious = this.element.querySelector('.pagination__nav--prev');
        this.buttonPaginationNext = this.element.querySelector('.pagination__nav--next');
        if (this.element.getAttribute('data-detail-url')) {
            this.attributeDetailPage = this.element.getAttribute('data-detail-url');
        }
        if (this.element.getAttribute('data-department')) {
            this.attributeDepartment = this.element.getAttribute('data-department');
            this.varDepartment = this.attributeDepartment;
        }
        this.getJobs();
        $(document).on('click', 'li.pagination__item', function (e) {
            var target = e.target;
            var page = target.getAttribute('data-page');
            var limit = target.getAttribute('data-limit');
            var offset = parseInt(page) * parseInt(limit);
            _this.varPaginationIndex = page;
            _this.varLimit = limit;
            _this.varOffset = offset;
            _this.getJobs();
            $('html,body').animate({
                scrollTop: 0
            }, 'slow');
        });
    };
    CareerProgrammeComponent.prototype.bindEvents = function () {
        var _this = this;
        this.buttonPaginationPrevious.addEventListener('click', function (e) {
            if (!_this.buttonPaginationPrevious.classList.contains('pagination__nav--disabled')) {
                _this.varPaginationIndex = _this.varPaginationIndex - 1;
                var offset = parseInt(_this.varPaginationIndex) * _this.varLimit;
                _this.varOffset = offset;
                _this.getJobs();
                $('html,body').animate({
                    scrollTop: 0
                }, 'slow');
            }
        });
        this.buttonPaginationNext.addEventListener('click', function (e) {
            if (!_this.buttonPaginationNext.classList.contains('pagination__nav--disabled')) {
                _this.varPaginationIndex = _this.varPaginationIndex + 1;
                var offset = parseInt(_this.varPaginationIndex) * _this.varLimit;
                _this.varOffset = offset;
                _this.getJobs();
                $('html,body').animate({
                    scrollTop: 0
                }, 'slow');
            }
        });
    };
    /////////////////////////////////////
    /////////////////////////////////////	
    //// GET JOBS
    /////////////////////////////////////
    /////////////////////////////////////	
    CareerProgrammeComponent.prototype.getJobs = function () {
        var _this = this;
        // postdata
        var postData = '';
        postData = postData + "?limit=" + this.varLimit;
        postData = postData + "&offset=" + this.varOffset;
        postData = postData + "&destination=" + this.varDestination;
        if (this.varLanguage) {
            postData = postData + "&language=" + this.varLanguage;
        }
        postData = postData + "&locationType=" + this.varLocationType;
        postData = postData + "&department=" + this.varDepartment;
        // functions
        var containerPagination = this.containerPagination;
        var generatePagination = this.generatePagination;
        var varPaginationIndex = this.varPaginationIndex;
        var buttonPaginationPrevious = this.buttonPaginationPrevious;
        var buttonPaginationNext = this.buttonPaginationNext;
        // variables
        var urlGeneric = this.varUrl + postData;
        // service
        axios.get(urlGeneric).then(function (response) {
            _this.buildLayout(response.data, _this.containerLoader, _this.containerResults, _this.containerEmpty, _this.attributeDetailPage);
            generatePagination(containerPagination, _this.varLimit, response.data.totalFound, varPaginationIndex, buttonPaginationPrevious, buttonPaginationNext);
        }).catch(function (error) {
            console.log(error);
        });
    };
    /////////////////////////////////////
    /////////////////////////////////////	
    //// BUILD LAYOUT
    /////////////////////////////////////
    /////////////////////////////////////	
    CareerProgrammeComponent.prototype.buildLayout = function (items, containerLoader, containerItems, containerEmpty, detailPageUrl) {
        if (items === void 0) { items = {}; }
        if (containerLoader === void 0) { containerLoader = undefined; }
        if (containerItems === void 0) { containerItems = undefined; }
        if (containerEmpty === void 0) { containerEmpty = undefined; }
        if (detailPageUrl === void 0) { detailPageUrl = ''; }
        // before completion
        containerItems.innerHTML = "";
        containerItems.classList.add('d-none');
        // more than 0 items
        if (items.totalFound > 0) {
            // create items
            var output_1 = "";
            if (items.content.length > 0) {
                var content = items.content;
                content.map(function (item) {
                    // check values
                    var releasedDate = "";
                    var featured = "";
                    var name = "";
                    var location = "";
                    var segment = "";
                    var employmentType = "";
                    var description = "";
                    // checks
                    if (item.releasedDate) {
                        var getTodaysDate = new Date();
                        var getTodaysDay = getTodaysDate.getDate();
                        var systemDate = new Date(item.releasedDate);
                        var systemDay = systemDate.getDate();
                        var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                        var systemDateFormatted = systemDate.getDate() + " " + monthNames[systemDate.getMonth()] + " " + systemDate.getFullYear();
                        var calculate = getTodaysDay - systemDay;
                        var dateFormatted = '';
                        switch (calculate) {
                            case 0:
                                dateFormatted = 'Posted today​';
                                break;
                            case 1:
                                dateFormatted = 'Posted 1 day ago';
                                break;
                            case 2:
                                dateFormatted = 'Posted 2 days ago';
                                break;
                            case 3:
                                dateFormatted = 'Posted 3 days ago';
                                break;
                            case 4:
                                dateFormatted = 'Posted 4 days ago';
                                break;
                            case 5:
                                dateFormatted = 'Posted 5 days ago';
                                break;
                            case 6:
                                dateFormatted = 'Posted 6 days ago';
                                break;
                            case 7:
                                dateFormatted = 'Posted 7 days ago';
                                break;
                            default:
                                dateFormatted = 'Posted ' + systemDateFormatted;
                        }
                        releasedDate = "<span class=\"career-search-component__item--date\">" + dateFormatted + "</span>";
                    }
                    if (item.department) {
                        if (item.department.id) {
                            var customLabel = item.department.label;
                            customLabel = customLabel.replace(' Job', '');
                            customLabel = customLabel.replace(' job', '');
                            customLabel = customLabel.replace(' JOB', '');
                            if (customLabel !== 'Standard') {
                                featured = "<span class=\"feature-badge career-search-component__item--badge\">\n\t\t\t\t\t\t\t\t\t" + customLabel + "\n\t\t\t\t\t\t\t\t</span>";
                            }
                        }
                    }
                    if (item.name) {
                        name = "<span class=\"career-search-component__item--title\">\n\t\t\t\t\t\t\t<h4 class=\"title title--module-sub-title \">\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t" + item.name + "\n\t\t\t\t\t\t\t</h4>\n\t\t\t\t\t\t</span>";
                    }
                    if (item.location) {
                        if (item.location.address) {
                            location += "" + item.location.address;
                        }
                        if (item.location.city) {
                            location += ", " + item.location.city;
                        }
                        if (item.location.region) {
                            location += ", " + item.location.region;
                        }
                        if (item.location.country) {
                            var countryUppercase = item.location.country;
                            location += ", " + countryUppercase.toUpperCase();
                        }
                    }
                    item.customField.map(function (customField) {
                        if (customField.fieldLabel === 'Business Segment') {
                            segment = customField.valueLabel;
                        }
                    });
                    if (item.typeOfEmployment) {
                        employmentType = item.typeOfEmployment.label;
                    }
                    output_1 += "<a href=\"" + detailPageUrl + "?jobID=" + item.id + "\" target=\"_blank\" class=\"career-search-component__item\" data-intent=\"informational\" data-scope=\"programmes-listing\" data-id=\"link_content\" data-text=\"" + item.name + " link click\">\n\t\t\t\t\t\t" + releasedDate + "\n\t\t\t\t\t\t" + featured + "\n\t\t\t\t\t\t" + name + "\n\t\t\t\t\t\t<span class=\"career-search-component__item--meta\">\n\t\t\t\t\t\t\t<span class=\"career-search-component__item--meta__segment\">\n\t\t\t\t\t\t\t\t<strong>Location:</strong> " + location + "\t\t\t\t\t\t\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span class=\"career-search-component__item--meta__segment\">\n\t\t\t\t\t\t\t\t<strong>Business segment:</strong> " + segment + "\t\t\t\t\t\t\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span class=\"career-search-component__item--meta__segment\">\n\t\t\t\t\t\t\t\t<strong>Type of Employment:</strong> " + employmentType + "\t\t\t\t\t\t\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</a>";
                });
                containerItems.innerHTML = output_1;
            }
            // after completion
            containerLoader.classList.add('d-none');
            containerItems.classList.remove('d-none');
        }
        else {
            containerLoader.classList.add('d-none');
            containerEmpty.classList.remove('d-none');
        }
    };
    /////////////////////////////////////
    /////////////////////////////////////	
    //// PAGINATION
    /////////////////////////////////////
    /////////////////////////////////////	
    CareerProgrammeComponent.prototype.generatePagination = function (container, limit, total, paginationIndex, paginationControlPrev, paginationControlNext) {
        if (container === void 0) { container = ""; }
        if (limit === void 0) { limit = 10; }
        if (total === void 0) { total = 0; }
        if (paginationIndex === void 0) { paginationIndex = 0; }
        if (paginationControlPrev === void 0) { paginationControlPrev = ""; }
        if (paginationControlNext === void 0) { paginationControlNext = ""; }
        if (total > 10) {
            container.classList.remove('d-none');
            var pagination = container.querySelector('.pagination__items');
            var calculate = parseInt(total) / parseInt(limit);
            var times = 0;
            if (calculate.toString().indexOf('.') > -1) {
                var number = parseInt(calculate.toString().split(".")[0]);
                times = number + 1;
            }
            else {
                times = calculate;
            }
            var output = "";
            for (var index = 0; index < times; index++) {
                if (paginationIndex === 0) {
                    paginationControlPrev.classList.add('pagination__nav--disabled');
                    paginationControlNext.classList.remove('pagination__nav--disabled');
                    if (index === 0) {
                        output += "<li class=\"pagination__item pagination__item--active\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                    }
                    else if (index === 1) {
                        output += "<li class=\"pagination__item\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                    }
                    else if (index === 2) {
                        output += "<li class=\"pagination__item\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                    }
                    else {
                        output += "<li class=\"pagination__item d-none\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                    }
                }
                else if (paginationIndex === (times - 1)) {
                    paginationControlPrev.classList.remove('pagination__nav--disabled');
                    paginationControlNext.classList.add('pagination__nav--disabled');
                    if (index === times) {
                        output += "<li class=\"pagination__item pagination__item--active\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                    }
                    else if (index === (times - 1)) {
                        output += "<li class=\"pagination__item\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                    }
                    else if (index === (times - 2)) {
                        output += "<li class=\"pagination__item\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                    }
                    else {
                        output += "<li class=\"pagination__item d-none\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                    }
                }
                else {
                    paginationControlPrev.classList.remove('pagination__nav--disabled');
                    paginationControlNext.classList.remove('pagination__nav--disabled');
                    var getPrevious = parseInt(paginationIndex) - 1;
                    var getCurrent = parseInt(paginationIndex);
                    var getNext = parseInt(paginationIndex) + 1;
                    if (index === getPrevious) {
                        output += "<li class=\"pagination__item\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                    }
                    else if (index === getCurrent) {
                        output += "<li class=\"pagination__item pagination__item--active\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                    }
                    else if (index === getNext) {
                        output += "<li class=\"pagination__item\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                    }
                    else {
                        output += "<li class=\"pagination__item d-none\" data-pagination-index=\"" + index + "\" tabindex=\"" + index + "\" role=\"button\" aria-label=\"Go to slide " + (index + 1) + "\" data-page=\"" + index + "\" data-limit=\"" + limit + "\">" + (index + 1) + "</li>";
                    }
                }
            }
            pagination.innerHTML = output;
        }
        else {
            container.classList.add('d-none');
        }
    };
    return CareerProgrammeComponent;
}(Base));
export { CareerProgrammeComponent };



//////////////////
// WEBPACK FOOTER
// ./components-career/career-programme-component/career-programme-component.component.ts
// module id = 668
// module chunks = 0